import React from "react";
import TransitVisaForm from "./TransitVisaForm";
import CommonCollapsible from "../../common/CommonCollapsible";
import {
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdDeleteForever,
} from "react-icons/md";

function BulkTransitVisaFormList({ forms, setForms, emptyForm }) {
  const addEntry = () => {
    setForms((prev) => [...prev, { ...emptyForm }]);
  };

  const removeEntry = (index) => {
    setForms((prev) => prev.filter((_, i) => i !== index));
  };

  const toggleOpen = (index) => {
    setForms((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, open: !item.open } : item
      )
    );
  };

  return (
    <div className="flex w-full flex-col gap-4 max-h-[60vh] overflow-y-auto scroll-hide">
      {forms.map((item, index) => (
        <div
          key={index}
          className="border rounded-lg bg-gray-50 flex flex-col gap-2 shadow-sm"
        >
          {/* Header */}
          <div
            className="flex justify-between items-center px-4 py-3 bg-gray-100 rounded-t-lg cursor-pointer"
            onClick={() => toggleOpen(index)}
          >
            <div className="font-medium text-gray-800">Entry #{index + 1}</div>

            <div className="flex items-center gap-3">
              <div className="text-gray-600 hover:text-black transition">
                {item.open ? (
                  <MdKeyboardArrowUp size={24} />
                ) : (
                  <MdKeyboardArrowDown size={24} />
                )}
              </div>

              {forms.length > 1 && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    removeEntry(index);
                  }}
                  className="text-red-600 hover:text-red-800 transition"
                >
                  <MdDeleteForever size={24} />
                </button>
              )}
            </div>
          </div>

          {/* Collapsible Panel */}
          <CommonCollapsible open={item.open}>
            <div className="p-4">
              <TransitVisaForm
                form={item}
                setForm={(updateFn) =>
                  setForms((prev) =>
                    prev.map((entry, i) =>
                      i === index ? { ...entry, ...updateFn(entry) } : entry
                    )
                  )
                }
              />
            </div>
          </CommonCollapsible>
        </div>
      ))}

      {/* Add new entry button */}
      <button
        onClick={addEntry}
        className="w-full border-2 border-dashed border-gray-300 hover:border-gray-400
               rounded-xl py-3 flex items-center justify-center gap-2
               text-gray-600 hover:text-gray-800 transition"
      >
        <span className="text-xl">＋</span>
        <span className="font-medium">Add Entry</span>
      </button>
    </div>
  );
}

export default BulkTransitVisaFormList;
